module.exports = __webpack_public_path__ + "img/27.610e87ce.jpg";